import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[ParkingBookings SetFilter] Action',
  ResetFilter: '[ParkingBookings ResetFilter] Action',
}

const initialParkingBookingsState: IParkingBookingsState = {
  filter: {
    siteId: '',
    dateFrom: '',
    dateTo: '',
  },
}

export interface IParkingBookingsState {
  filter?: {
    siteId: string
    dateFrom: string
    dateTo: string
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-ParkingBookings', whitelist: ['filter']},
  (
    state: IParkingBookingsState = initialParkingBookingsState,
    action: ActionWithPayload<IParkingBookingsState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialParkingBookingsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
